// extracted by mini-css-extract-plugin
module.exports = {"card_header":"ComposicionCartera__card_header__2cWjA","card_header2":"ComposicionCartera__card_header2__2bzLg","titulo_ZIP":"ComposicionCartera__titulo_ZIP__19Tzu"};